import script from "./Order.vue?vue&type=script&setup=true&lang=ts"
export * from "./Order.vue?vue&type=script&setup=true&lang=ts"

import "./Order.vue?vue&type=style&index=0&id=1f09ff80&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f09ff80"]])

export default __exports__